import { render, staticRenderFns } from "./BaseAutocompletePlace.vue?vue&type=template&id=60621658&scoped=true&"
import script from "./BaseAutocompletePlace.vue?vue&type=script&lang=js&"
export * from "./BaseAutocompletePlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60621658",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VFlex,VLayout})
